import CryptoJS from "crypto-js"
import { Config } from "config/config"

export const easyEncrypt = (word: string) => {
  return CryptoJS.AES.encrypt(word, Config.api.auth.key).toString()
}

export const easyDecrypt = (word: string) => {
  return CryptoJS.AES.decrypt(word, Config.api.auth.key).toString(
    CryptoJS.enc.Utf8
  )
}

export const encrypt = (str: string, passphrase: string) => {
  const secret_passPhrase = CryptoJS.enc.Utf8.parse(passphrase)
  const salt = CryptoJS.lib.WordArray.random(128 / 8)
  const key128Bits500Iterations = CryptoJS.PBKDF2(secret_passPhrase, salt, {
    keySize: 128 / 8,
    iterations: 500,
  })
  const iv = CryptoJS.lib.WordArray.random(128 / 8)
  const options = {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }
  const message_text = CryptoJS.enc.Utf8.parse(str)
  const encrypted = CryptoJS.AES.encrypt(
    message_text,
    key128Bits500Iterations,
    options
  )
  let binary_data = CryptoJS.enc.Hex.stringify(salt)
  binary_data += "," + CryptoJS.enc.Hex.stringify(iv)
  binary_data += "," + encrypted
  return binary_data
}

export const decrypt = (encrypt_data: string, passphrase: string) => {
  const array_rawData = encrypt_data.split(",")
  const salt = CryptoJS.enc.Hex.parse(array_rawData[0])
  const iv = CryptoJS.enc.Hex.parse(array_rawData[1])
  const encrypted_data = CryptoJS.enc.Base64.parse(array_rawData[2])
  const secret_passphrase = CryptoJS.enc.Utf8.parse(passphrase)
  const key128Bits500Iterations = CryptoJS.PBKDF2(secret_passphrase, salt, {
    keySize: 128 / 8,
    iterations: 500,
  })
  const options = {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }
  let decrypted = CryptoJS.AES.decrypt(
    encrypted_data,
    key128Bits500Iterations,
    options
  )
  return decrypted.toString(CryptoJS.enc.Utf8)
}
